﻿import React from 'react';
import {MenuItem, MenuItemProps} from "@mui/material";

interface ActionsMenuItemProps extends MenuItemProps {
  /** When false, the MenuItem is not mounted. Defaults to true. */
  visible?: boolean;
}

/**
 * MUI Grid Passthrough component for now since we don't have any global styles being reused for MenuItem atm.
 * Can be used to style all MenuItems in the future if we change our design specs. It uses the typeof MenuItem in order
 * to trick Menu into thinking these are actual MenuItems because MUI Menu uses special logic on MenuItems which would
 * otherwise need to be replicated. Based on current use-cases it will most likely hold an Icon followed by an ItemLabel
 * @param props MenuItemProps passthrough to the internal MenuItem, plus `visible` to control mounting
 * @constructor
 */
const ActionsMenuItem = ({ children, visible = true, ...rest }: ActionsMenuItemProps) => {
  if (!visible) {
    return null;
  }

  return <MenuItem {...rest} >
    { children }
  </MenuItem>
}

export { ActionsMenuItem };

